import React, { Component } from "react";
import { Input } from "reactstrap";
import MPSSelect from "../../../../components/MPSSelect";
import FeaturesService from "../../../../services/featuresService";
import MPSTypeaheadSelect from "../../../../components/MPSTypeaheadSelect/MPSTypeaheadSelect";
import terminologyService from "../../../../services/terminologyService";

class CCCObservation extends Component {
  static getDisplayValue(attributeValue) {
    if (
      attributeValue.valueObservation &&
      attributeValue.valueObservation.value &&
      attributeValue.valueObservation.value.valueCode
    ) {
      return attributeValue.valueObservation.value.valueCode.display;
    }
  }

  static getDisplayValueInFilter(attributeValue) {
    if (
      attributeValue.valueObservation &&
      attributeValue.valueObservation.value &&
      attributeValue.valueObservation.value.valueCode
    ) {
      return attributeValue.valueObservation.value.valueCode.code;
    }
    return null;
  }

  static getOptionsList(options = []) {
    return options.map(option => {
      let val = option.valueObservation.value.valueCode;
      return {
        value: val.code,
        label: val.display
      };
    });
  }

  render() {
    let { attributeValue, choiceList, options = [], setData } = this.props;

    attributeValue.valueObservation = attributeValue.valueObservation || {};
    attributeValue.valueObservation.value =
      attributeValue.valueObservation.value || {};
    let obsVal = attributeValue.valueObservation.value.valueCode
      ? attributeValue.valueObservation.value.valueCode.code
      : null;

    // Terminology typeahead: when attribute has terminologyLookup, choiceList is on, and feature flag is on
    let terminologyLookup = this.props.terminologyLookup;
    if (
      FeaturesService.isTerminologyEnabled() &&
      terminologyLookup &&
      choiceList
    ) {
      if (this.props.observationCode) {
        attributeValue.valueObservation.code = this.props.observationCode;
      }
      const searchFn = terminologyService.getSearchFnForLookup(
        terminologyLookup
      );
      const isECL = terminologyService.isECLLookup(terminologyLookup);
      let currentValueCode = attributeValue.valueObservation.value.valueCode;
      return (
        <div className="inputHolder flex-row">
          <MPSTypeaheadSelect
            searchFn={searchFn}
            eagerLoad={isECL}
            value={
              currentValueCode
                ? { code: currentValueCode.code, display: currentValueCode.display }
                : null
            }
            onChange={(selected) => {
              if (selected) {
                attributeValue.valueObservation.value.valueCode = {
                  code: selected.code,
                  display: selected.display,
                  system: selected.system,
                };
              } else {
                attributeValue.valueObservation.value.valueCode = null;
              }
              setData(attributeValue);
              if (this.props.onBlur) {
                setTimeout(() => this.props.onBlur(), 0);
              }
            }}
            showSystem
          />
        </div>
      );
    }

    if (choiceList) {
      return (
        <div className="inputHolder flex-row">
          <MPSSelect
            className="ui-attribute-el-select"
            style={{
              minWidth: "175px",
              with: "auto",
              color: "#3e515b"
            }}
            name="form-field-name"
            value={obsVal}
            onChange={option => {
              if (option) {
                // attributeValue.valueObservation.value = option.valObj;
                attributeValue = option.valObj;
                // attributeValue.valueObservation.value.valueCode =
                //   option.value;
                // attributeValue.valueObservation.code =
                //   attributeValue.valueObservation.code || observationCode;
              } else {
                attributeValue.valueObservation.value = {};
                // attributeValue.valueObservation.code = {};
              }
              setData(attributeValue);
              // Save immediately after selection for better UX with conditional fields
              if (this.props.onBlur) {
                setTimeout(() => this.props.onBlur(), 0);
              }
            }}
            options={options
              .filter(
                o =>
                  o.valueObservation &&
                  o.valueObservation.value &&
                  o.valueObservation.value.valueCode
              )
              .map(option => {
                let val = option.valueObservation.value.valueCode;
                return {
                  value: val.code,
                  valObj: JSON.parse(JSON.stringify(option)),
                  label: val.display
                };
              })}
            onBlur={this.props.onBlur}
          />
        </div>
      );
    } else {
      let displayVal = attributeValue.valueObservation.value.valueCode
        ? (attributeValue.valueObservation.value.valueCode.display || attributeValue.valueObservation.value.valueCode.code || "")
        : "";
      return (
        <div>
          <div className="inputHolder">
            <Input
              value={displayVal}
              onChange={e => {
                const val = e.target.value;
                attributeValue.valueObservation.value.valueCode = {
                  code: val,
                  display: val,
                };
                setData(attributeValue);
              }}
              type="text"
              onBlur={this.props.onBlur}
              className="ui-attribute-el"
            />
          </div>
        </div>
      );
    }
  }
}

export default CCCObservation;
